import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { IndustriesComponent } from './industries.component';

@NgModule({
  declarations: [
    IndustriesComponent
  ],
  imports:[BrowserModule],
  exports:[IndustriesComponent],
  providers: [],
})
export class IndustriesModule { }



// WEBPACK FOOTER //
// ./src/app/industries/industries.module.ts